<template>
  <v-dialog v-model="open" max-width="900px" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon="mdi-clock-outline"
          icon-action="mdi-pencil-outline"
          :title="title"
          v-bind="attrs"
          v-on="on"
      >
        <template slot:subtitle>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="(time, index) in resumeItems" :key="index">
                  <td :class="{'td-day': time.label !== ''}">{{ time.label }}</td>
                  <td>{{ getResumeItemLabel(time) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </location-info-item>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          {{ title }}
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
            @submit="e => e.preventDefault()"
        >
          <location-more-schedule-list
              v-bind:value="formData.more_hours"
              v-on:change="updateData"
              :limit="3"
              add-text="Adicionar horário"
          />

          <v-alert
              v-if="alertScheduledTask"
              dense
              border="right"
              type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex'
import {TYPE_UPDATE_LOCATION_MORE_HOUR} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import LocationMoreScheduleList from "../Components/LocationMoreScheduleList";
import {get} from 'lodash'

export default {
  name: "LocationMoreScheduleModal",
  props: {
    title: String,
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: Array,
    hourType: String
  },
  computed: {
    ...mapState({
      location: state => state.locations.location
    }),
    days() {
      return {
        MONDAY: 'Segunda-feira',
        TUESDAY: 'Terça-feira',
        WEDNESDAY: 'Quarta-feira',
        THURSDAY: 'Quinta-feira',
        FRIDAY: 'Sexta-feira',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo'
      }
    }
  },
  components: {
    ScheduleForm,
    LocationMoreScheduleList,
    LocationInfoItem
  },
  beforeDestroy() {
    this.resetData()
  },
  data: () => ({
    resumeItems: [],
    open: false,
    loading: false,
    formValid: true,
    value: {},
    moreHours: {},
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_MORE_HOUR,
      more_hours: {},
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
    },
    alertScheduledTask: null,
  }),
  mounted() {
    if (this.location && !this.bulkUpdate) {
      this.formDataOriginal.more_hours = get(this.location, 'data.moreHours', {})
      this.moreHours = get(this.location, 'data.moreHours', {})
      if(this.moreHours[this.hourType]) {
        this.formData.more_hours = this.moreHours[this.hourType]
      }
    }

    this.getResumeInfo()

    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_MORE_HOUR) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  methods: {
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      this.moreHours = get(this.location, 'data.moreHours', {})
      if(this.moreHours[this.hourType]) {
        this.formData.more_hours = this.moreHours[this.hourType]
      }
      this.value = {}
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'more_hours')
      }
    },
    callAction: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let data = { ...this.formData }
        let moreHours = []

        if(!this.bulkUpdate) {
          delete this.formDataOriginal.more_hours[this.hourType]
          for (const index in this.formDataOriginal.more_hours) {
            for (const day in this.formDataOriginal.more_hours[index]) {
              const items = this.formDataOriginal.more_hours[index][day] && this.formDataOriginal.more_hours[index][day] || []
              items.forEach(item => {
                if (item.open_time && item.close_time) {
                  moreHours.push({
                    open_time: item.open_time,
                    close_time: item.close_time,
                    open_day: item.open_day || day,
                    close_day: item.close_day || day,
                    hours_type_id: item.hours_type_id,
                    is_24_hours: false
                  })
                } else if (item.is_24_hours) {
                  moreHours.push({
                    open_time: '',
                    close_time: '',
                    open_day: item.open_day || day,
                    close_day: item.close_day || day,
                    hours_type_id: item.hours_type_id,
                    is_24_hours: true
                  })
                }
              })
            }
          }
        }

        for (const day in this.formData.more_hours) {
          const items = this.formData.more_hours[day] && this.formData.more_hours[day] || []
          items.forEach(item => {
            if (item.open_time && item.close_time) {
              moreHours.push({
                open_time: item.open_time,
                close_time: item.close_time,
                open_day: item.open_day || day,
                close_day: item.close_day  || day,
                hours_type_id: this.hourType,
                is_24_hours: false
              })
            } else if (item.is_24_hours) {
              moreHours.push({
                open_time: '',
                close_time: '',
                open_day: item.open_day || day,
                close_day: item.close_day  || day,
                hours_type_id: this.hourType,
                is_24_hours: true
              })
            }
          })
        }
        data.more_hours = moreHours
        if (this.bulkUpdate) {
          this.$emit('savePayload', 'more_hours', data.more_hours);
        } if (this.action) {
          await this.action(data)
        }
        this.open = false
        this.loading = false
      }
    },
    changeScheduleDate(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    },
    updateData(values) {
      this.formData.more_hours = values
      this.getResumeInfo()
    },
    getResumeInfo() {
      let items = []
      for (const day in this.days) {
        if (this.formData && this.formData.more_hours && this.formData.more_hours[day]) {
          let timeIndex = 0
          for (const time of this.formData.more_hours[day]) {
            const label = timeIndex === 0 ? this.days[day] : ''
            items.push({ label, ...time })
            timeIndex++
          }
        } else {
          items.push({ label: this.days[day], open: false })
        }
      }
      this.resumeItems = items
    },
    getResumeItemLabel(time) {
      if (time.is_24_hours) {
        return '24 horas'
      }

      if (time && time.open === false) {
        return 'Fechado'
      }

      return `${time.open_time} - ${time.close_time}`
    }
  },
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.formDataOriginal.more_hours = get(location, 'data.moreHours', {})
        this.moreHours = get(location, 'data.moreHours', {})
        if(this.moreHours[this.hourType]) {
          this.formData.more_hours = this.moreHours[this.hourType]
        }
      }
      this.getResumeInfo()
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.formDataOriginal.more_hours = get(this.location, 'data.moreHours', {})
        this.moreHours = get(this.location, 'data.moreHours', {})
        if(this.moreHours[this.hourType]) {
          this.formData.more_hours = this.moreHours[this.hourType]
        }
      }
      this.getResumeInfo()
    }
  }
}
</script>

<style scoped>
::v-deep td {
  border: none !important;
  padding-left: 0 !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

::v-deep td.td-day {
  width: 110px;
}

::v-deep tr:hover {
  background-color: transparent !important;
}
</style>